import { Stack } from '@mui/material'
import type { Hole, RootEntity } from 'metalworks-domain'
import { Handing } from 'metalworks-domain'

import { DistanceDimensionInput } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { configuratorInterface } from '../../systems/configurator-interface'
import { AnchorPointsToggle } from '../AnchorPointsToggle'

interface GenericDistancePropertyPageProps {
  id: Hole['id']
}

export const GenericDistancePropertyContainerItem = (props: GenericDistancePropertyPageProps) => {
  const { id } = props

  const { storeSystem } = configuratorInterface.useDomain()
  const domainState = storeSystem.stateSlices.committed.value.state
  const plateId = domainState.rootEntityId as RootEntity['id']

  const { handing } = configuratorInterface.useEntityState(plateId)

  return (
    <PropertyContainer.Item title="Position">
      <Stack direction="row" gap={2}>
        <DistanceDimensionInput entityId={id} instanceName="x" inputLabel="X coordinate" />
        <DistanceDimensionInput entityId={id} instanceName="y" inputLabel="Y coordinate" />
      </Stack>
      {handing === Handing.reverse && <small>X coordinates on a reversed plate are measured from right to left.</small>}
    </PropertyContainer.Item>
  )
}

export const GenericDistancePropertyPage = (props: GenericDistancePropertyPageProps) => (
  <PropertyContainer.Group spacing="large">
    <GenericDistancePropertyContainerItem {...props} />
    <AnchorPointsToggle />
  </PropertyContainer.Group>
)
